import axios from "axios";

async function getConsentTypesApi() {
    return axios({
        method: 'GET',
        url: '/api/v1/consents'
    });
}

async function postConsentTypeApi(name:string, content:string){
    return axios({
        method:'POST',
        url: '/api/v1/consents',
        data:{ name, content }
    })
}

async function getConsentTypeApi(consentUuid: string){
    return axios({
        method:"GET",
        url: `/api/v1/consents/${consentUuid}`
    })
}

async function patchConsentTypeApi(consentUuid:string, name: string, content: string){
    return axios({
        method:"PATCH",
        url: `/api/v1/consents/${consentUuid}`,
        data:{name, content}
    })
}

export {
    getConsentTypesApi,
    postConsentTypeApi,
    getConsentTypeApi,
    patchConsentTypeApi
}
